import styled from "styled-components";

export const ButtonsContainer = styled.div`
  display: flex;
  column-gap: 24px;
  justify-content: center;

  button {
    margin: 0;
  }

  @media ${(props) => props.theme.device.mobileL}   {
    flex-direction: column-reverse;
    row-gap: 8px;
  }
`;
